import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { useTranslation } from 'react-i18next';
import { LuClipboardList } from 'react-icons/lu';

import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsModalNavigation } from '~/features/leadDetails/hooks/useLeadDetailsModalNavigation';

const LookupFormLoanButton: React.FC = () => {
    const { t } = useTranslation();
    const { openModal } = useLeadDetailsModalNavigation();

    return (
        <Button
            variant={ButtonVariant.SECONDARY}
            iconLeft={<LuClipboardList />}
            onClick={() => openModal(LEAD_DETAILS_OVERLAYS.FORM_LOANS)}
        >
            {t('EXISTING_LOANS.LOOKUP_FORM')}
        </Button>
    );
};

export default LookupFormLoanButton;
